var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 11.85V15.1M6.3 8.6H16.7L15.673 17.843C15.6378 18.1611 15.4865 18.455 15.2481 18.6685C15.0096 18.882 14.7008 19 14.3808 19H8.6192C8.29916 19 7.99037 18.882 7.75194 18.6685C7.51351 18.455 7.3622 18.1611 7.327 17.843L6.3 8.6ZM8.47425 6.74555C8.57939 6.52258 8.74576 6.3341 8.95395 6.20209C9.16215 6.07009 9.40358 6 9.6501 6H13.3499C13.5965 5.99987 13.8381 6.06991 14.0464 6.20192C14.2547 6.33393 14.4212 6.52248 14.5264 6.74555L15.4 8.6H7.6L8.47425 6.74555V6.74555ZM5 8.6H18H5ZM10.2 11.85V15.1V11.85Z",
    stroke: "#EF5E3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.91216984a77346182557122d8e08799f.svg";
export { ForwardRef as ReactComponent };